export enum FeatureFlags {
  // TODO Remove `Test` once we have an actual flag via this ticket
  // {@link https://app.asana.com/0/1200752529105818/1207978367908655/f}
  Test = 'test',
}

export enum FeedContentType {
  Advertisement = 'Advertisement',
  Article = 'Article',
  Briefing = 'Briefing',
  Newsletter = 'Newsletter',
  TITVStream = 'TITVStream',
  VideoUpload = 'VideoUpload',
}

export enum FormLocation {
  ProjectPaywall = 'project_paywall',
  DeepResearch = 'deep_research',
  FinanceLandingPage = 'finance_landing_page',
  Footer = 'footer',
  Gift = 'gift',
  LeadStickyBanner = 'lead_sticky_banner',
  LegacyProject = 'legacy_project',
  Login = 'login',
  MarketingModal = 'marketing_modal',
  NewsletterLanding = 'newsletter_landing',
  NewsletterSignup = 'newsletter_signup',
  OrgChartsLanding = 'org_charts_landing',
  OrgSignup = 'org_signup',
  Paywall = 'paywall',
  PaywallStickyBanner = 'paywall_sticky_banner',
  ProLeadCaptureForm = 'pro_lead_capture_form',
  ProPaywall = 'pro_paywall',
  ReadThisArticle = 'read_this_article',
  RightRail = 'right_rail',
  ShareWithOauth = 'share_with_oauth',
  SpecialOfferBanner = 'special_offer_banner',
  Subscribe = 'subscribe',
  SubscribeModal = 'subscribe_modal',
  TeamLeadCapture = 'team_lead_capture',
  TITV = 'titv',
  WeekendSubscribeForm = 'weekend_subscribe_form',
}

export enum LeadTypes {
  ArticleLead = 'article_lead',
  BrandPartnershipInbound = 'bp_inb_form',
  BriefingLead = 'briefing_lead',
  ChartsLead = 'charts_lead',
  Corporate = 'corporate',
  CorportateGovernance = 'corporate-governance',
  CorporateInbound = 'corp_inb_form',
  DeepResearchPaywall = 'deep_research_paywall',
  DiversityIndexLead = 'diversity_index_lead',
  Footer = 'footer',
  FooterTargetNewsletters = 'footer_target_newsletters',
  ForumPost = 'forum_post',
  Gift = 'gift',
  HiringTalent = 'hiring-talent',
  Insider = 'insider',
  MarketingModal = 'marketing_modal',
  NewsletterLead = 'newsletter_lead',
  Organic = 'organic',
  OrgEmailDomain = 'org_email_domain',
  Paywall = 'paywall',
  Promo = 'promo',
  ReferralPage = 'referral_page_lead',
  Referred = 'referred',
  ShareArticle = 'share_article',
  SubHoverAnnual = 'sub_hover_annual',
  SubHoverPro = 'sub_hover_pro',
  SubscribePage = 'subscribe_page_lead',
  SubscribeTestPage = 'sub_2c',
  SubscriberProfile = 'subscriber_profile',
  Team = 'team',
  TITVDailyShowNewsletterSignup = 'titv_daily_show_newsletter_signup',
  TITVEpisodeRailNewsletterSignup = 'titv_epi_pgs_rail_newsletter_signup',
  TITVLandingRailNewsletterSignup = 'titv_lp_rail_newsletter_signup',
  TITVNewslettersSignup = 'titv_newsletters_signup',
  TITVRocketShowNewsletterSignup = 'titv_rocket_show_newsletter_signup',
  TechExports = 'tech-exports',
  TIApp = 'ti_app',
}
